import { Access, SalesChannel } from "../../models";
import { DMath } from "../../utils/DMath";

/**
 * The sales dashboard, counters and cashier shifts are available to anyone
 * who sells through any channel.
 */
export const SALES_DASHBOARD_ACCESS = [
  Access.SALE,
  Access.ORDER,
  Access.RESTAURANT,
  Access.OUTDOOR_ORDER,
  Access.SALE_APP,
  Access.CAPTAIN_APP,
  Access.INVOICE,
];

export const hasSalesDashboardAccess = (access: Array<string> = []) =>
  SALES_DASHBOARD_ACCESS.some((a) => access.includes(a));

/** Channels the user can see, as the API expects them. */
export const getSalesChannels = (access: Array<string> = []) => {
  const channels: Array<string> = [];
  if (access.includes(Access.SALE) || access.includes(Access.SALE_APP)) {
    channels.push(SalesChannel.SALE);
  }
  if (access.includes(Access.ORDER)) {
    channels.push(SalesChannel.ORDER);
  }
  if (
    access.includes(Access.RESTAURANT) ||
    access.includes(Access.CAPTAIN_APP)
  ) {
    channels.push(SalesChannel.RESTAURANT);
  }
  if (access.includes(Access.OUTDOOR_ORDER)) {
    channels.push(SalesChannel.OUTDOOR_ORDER);
  }
  if (access.includes(Access.INVOICE)) {
    channels.push(SalesChannel.INVOICE);
  }
  return channels;
};

export const CHANNEL_LABEL: { [k: string]: string } = {
  [SalesChannel.SALE]: "Sales",
  [SalesChannel.ORDER]: "Orders",
  [SalesChannel.RESTAURANT]: "TableOrders",
  [SalesChannel.OUTDOOR_ORDER]: "OutdoorOrders",
  [SalesChannel.INVOICE]: "Invoices",
  [SalesChannel.CUSTOMER]: "Customers",
  [SalesChannel.PURCHASE]: "Purchases",
  [SalesChannel.SUPPLIER]: "Suppliers",
  [SalesChannel.EXPENSE]: "Expenses",
  [SalesChannel.INCOME]: "Income",
};

/** Payment rows without an account (customer balance, loyalty points). */
export const getAccountTypeLabel = (t: any, accountType: string | null) =>
  accountType ? t(accountType) : t("OtherPayments");

/** Change against the previous period, in percent (null when not comparable). */
export const getChange = (current: any, previous: any) =>
  DMath.gt(previous, 0)
    ? DMath.toFixed(
        DMath.mul(DMath.div(DMath.sub(current, previous), previous), 100),
        1,
      )
    : null;

export const formatAmount = (symbol: string, value: any) =>
  `${symbol || ""}${DMath.toFixed(value || 0)}`;

export const toHourLabel = (hour: number) =>
  `${String(hour).padStart(2, "0")}:00`;
